export const TraitIds = [
  'advisorInformation',
  'agronomicDataCsv',
  'amendment',
  'amendmentSummary',
  'biological',
  'biomassBurning',
  'cashCrop',
  'commitment',
  'cornNitrogenApplication',
  'cottonNitrogenReduction',
  'conservationPrograms',
  'coverCrop',
  'cropManagementData',
  'daFieldId',
  'dairySoilsEnrollment',
  'enrolledOtherCarbon',
  'enrolledInUSCottonTrust',
  'description',
  'earlyAdopterTillage',
  'eqipSigningAuthority',
  'eqipApplicationResults',
  'eqipAutogenRequiredForms',
  'eqipContractResults',
  'eqipCurrentPractices',
  'eqipDocuments',
  'eqipEntity',
  'eqipEligibilityConservationACEP',
  'eqipEligibilityConservationCRP',
  'eqipEligibilityConservationCSP',
  'eqipEligibilityFarmInfo',
  'eqipEligibilityLandControl',
  'eqipEligibilityWetlandCompliance',
  'eqipEngagementFarmInfo',
  'eqipFarmInformation',
  'eqipFarmNumbers',
  'eqipFsaForms',
  'eqipGrowerDetails',
  'eqipHasFarmInfo',
  'eqipNrcsPermission',
  'eqipOptionalForms',
  'eqipPLUId',
  'eqipPracticeChoiceAgroforestry',
  'eqipPracticeChoiceEngineeringLandErosionStructures',
  'eqipPracticeChoiceEngineeringWaterControlStructures',
  'eqipPracticeChoiceSoil',
  'eqipPracticeChoiceWildlife',
  'eqipPracticeSelectionConfirmation',
  'eqipPracticesFlooding',
  'eqipPracticesIrrigationMethod',
  'eqipPracticesIrrigationQuantity',
  'eqipPracticesNaturalMoisture',
  'eqipPracticesSeeps',
  'eqipPracticesSnowDrifts',
  'eqipPracticesSoilCompaction',
  'eqipPracticesSoilCover',
  'eqipPracticesSoilErosionClassicalGully',
  'eqipPracticesSoilErosionEphemeralGully',
  'eqipPracticesSoilSalinity',
  'eqipPracticesSoilSubsidence',
  'eqipPracticesWaterTable',
  'eqipRecommendedPracticesIntent',
  'eqipRequiredForms',
  'eqipReviewRecommendationResults',
  'eqipSelectedPractices',
  'eventIrrigation',
  'farmManagementSystem',
  'fertilizer',
  'fertilizerReduction',
  'fmsSystem',
  'futureCashCrop',
  'futureCoverCrop',
  'futureLivestockChange',
  'futureTillage',
  'geometry',
  'governmentFunded',
  'grazing',
  'includesWetlandDesignation',
  'irrigation',
  'liming',
  'livestock',
  'lolFarmId',
  'name',
  'nativeVegetationConversion',
  'nativeVegetationConversionDate',
  'naturalDisturbance',
  'offer',
  'onFarmDairyFeed',
  'ownership',
  'practiceSelectionIntentFromPoints',
  'preferredRankPractice',
  'proofOfLandControl',
  'productAppliedPerPlan',
  'shipmentDistance',
  'summaryFootprint',
  'tillage',
  'usdaAgiThreshold',
  'usdaFederalProgramEnrollment',
  'usdaGrowerDetails',
  'usdaEarlyAdopter',
  'usdaGrowerType',
  'usdaGrowerTypeYearly',
  'usdaUnderservedSmall',
  'waterPumpIrrigation',
  'xtremeAgCode',
] as const

export type DataEntryTraitId = string

export type TraitId = typeof TraitIds[number] | DataEntryTraitId

export type Trait = {
  fields: {
    traitId: TraitId
    description: string
  }
}

export interface TraitStatus {
  traitId: TraitId
  missing: boolean
  failing: boolean
  missingOptional: boolean
}

// This was from v1 where we didn't have task order
export const TRAIT_ORDER = [
  'nativeVegetationConversionDate',
  'includesWetlandDesignation',
  'ownership',
  'farmManagementSystem',

  'biomassBurning',
  'livestock',
  'grazingEvents',
  'cashCrop',
  'coverCrop',
  'tillage',
  'fertilizer',
  'amendment',
  'irrigation',
  'agronomicDataCsv',

  'futureCashCrop',
  'futureCoverCrop',
  'futureTillage',
  'fertilizerReduction',
  'futureLivestockChange',
] as TraitId[]
export const ORDER_BY_TRAIT_ID: Record<TraitId, number> = TRAIT_ORDER.reduce(
  (acc, item, index) => ({ ...acc, [item]: index }),
  {} as Record<TraitId, number>
)
